// extracted by mini-css-extract-plugin
export default {"container":"FtKay9qtcp0rkPViZ9or","title":"QCkNcqiEFl67ILCJskmV","colorName":"KP40K4L1Fxf0CzwF1yzI","colorsContainer":"MbyExwNAKhMy4E6CM_E1"};